import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Icon } from 'copilot-design-system';
import React from 'react';
import { SendButtonProps } from 'stream-chat-react';

export const SendButton: React.FC<
  SendButtonProps & { showMessagingSidebar?: boolean }
> = React.memo(({ sendMessage, showMessagingSidebar = false }) => {
  const theme = useTheme();

  const handleClickSend = (e: React.BaseSyntheticEvent) => {
    sendMessage(e);
  };

  return (
    <IconButton
      color="primary"
      onClick={handleClickSend}
      style={{
        backgroundColor: theme.palette.primary.main,
      }}
      className={clsx('h-[35px] w-[35px] absolute right-5 bottom-3', {
        'sm:right-12 sm:bottom-[22px]': showMessagingSidebar,
        'sm:right-5 sm:bottom-[20.8px]': !showMessagingSidebar,
      })}
    >
      <Icon icon="SendFilled" className="w-4 h-4 shrink-0" />
    </IconButton>
  );
});
